import imagesSizes from "constants/imagesSizes";
import { Story } from "chq";

export const getMediaFromStory = (size: number, story: Story) => {
  if (story.media.mediaType === "video") {
    if (size === imagesSizes.SHAREABLE) {
      return story?.media?.shareableUrl || story?.media?.url;
    }

    return story?.media?.url;
  }
  switch (size) {
    case imagesSizes.THUMB:
      return story?.media?.thumbnail || story?.media?.url;
    case imagesSizes.SMALL:
      return story?.media?.smallUrl || story?.media?.url;
    case imagesSizes.NORMAL:
      return story?.media?.url;
    case imagesSizes.FULL:
    case imagesSizes.SHAREABLE:
      return story?.media?.fullUrl || story?.media?.url;
    default:
      return "";
  }
};

export default getMediaFromStory;
